import createIcon from '../../createIcon';

/**
 * @component @name MyLocation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgOEM5Ljc5IDggOCA5Ljc5IDggMTJDOCAxNC4yMSA5Ljc5IDE2IDEyIDE2QzE0LjIxIDE2IDE2IDE0LjIxIDE2IDEyQzE2IDkuNzkgMTQuMjEgOCAxMiA4Wk0yMC45NCAxMUMyMC40OCA2LjgzIDE3LjE3IDMuNTIgMTMgMy4wNlYxSDExVjMuMDZDNi44MyAzLjUyIDMuNTIgNi44MyAzLjA2IDExSDFWMTNIMy4wNkMzLjUyIDE3LjE3IDYuODMgMjAuNDggMTEgMjAuOTRWMjNIMTNWMjAuOTRDMTcuMTcgMjAuNDggMjAuNDggMTcuMTcgMjAuOTQgMTNIMjNWMTFIMjAuOTRaTTEyIDE5QzguMTMgMTkgNSAxNS44NyA1IDEyQzUgOC4xMyA4LjEzIDUgMTIgNUMxNS44NyA1IDE5IDguMTMgMTkgMTJDMTkgMTUuODcgMTUuODcgMTkgMTIgMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MyLocation = createIcon('MyLocation', [
  [
    'path',
    {
      d: 'M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z',
      key: 'mhf60y',
    },
  ],
]);

export default MyLocation;
